import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
  ) {
    deleteOneActiveSubstance(
      where: {
        id: $id
      }
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Substância activa eliminada`, mutationTypes.DELETE)
)

